import BTButton from '@common-components/bt-button/bt-button'
import BTtextFieldWithLabel from '@common-components/bt-input-field-with-label/bt-input-field-with-label'
import { Divider, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Stack } from '@mui/material'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { addNewBoardThunk, setSelectedBoardId } from '@common-reducers/BoardsThunks'
import { bulkActions } from '@common-reducers/BulkActionsReducer'
import { modalActions } from '@common-reducers/ModalReducer'
import { taskActions } from '@common-reducers/TasksReducer'
import { useRouter } from '@common-reducers/hooks/use-router'
import { useAppDispatch } from '@common-reducers/hooks/store.hook'
import EmojiPicker from '@/common/components/lazy-emoji-picker/lazy-emoji-picker'
import React, { useState } from 'react'

function NewBoardDialog() {
    const dispatch = useAppDispatch()
    const router = useRouter();
    const [selectedValue, setSelectedValue] = useState('default');
    const [isNewBoardLoading, setIsNewBoardLoading] = useState(false);
    const [emoji, setEmoji] = useState('😊');
    const [boardName, setBoardName] = useState<string>("");
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);


    const setBoardIcon = (arg: { emoji: string }) => {
        setEmoji(arg.emoji);
        setIsEmojiPickerOpen(false)
    }

    const options = [
        'tasks', 'recruiting', 'employees', 'clients', 'leads', 'campaigns'];

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
    };

    const createBoard = async () => {
        setIsNewBoardLoading(true);
        const res: any = await dispatch(addNewBoardThunk({ boardName: boardName, emoji: emoji, template: selectedValue }));

        const boardId = res.payload;
        setIsNewBoardLoading(false);
        if (boardId) {
            dispatch(setSelectedBoardId({ boardId }));
            dispatch(taskActions.setCurrentBoardView({
                type: 'board',
                id: boardId
            }
            ))
            dispatch(taskActions.setPersonFilter(""));
            dispatch(bulkActions.setBulkTasksMap({}));
            dispatch(taskActions.setViewMode('tasks'))
            dispatch(modalActions.setComponentToRender(''))
            router.navigate(`/tasks/?boardID=${boardId}`);
           
        }
     

    }
    return (
        <Stack px={6} py={2} spacing={2}>
            <h2 style={{ padding: 0, margin: 0 }}>Create Board</h2>
            <Stack direction="row">
                {/* Radix Popover (not MUI Menu): this dialog is a Radix Dialog at Z_LAYERS.dialog,
                    so an MUI Menu (z-index 1300) rendered behind it */}
                <Popover open={isEmojiPickerOpen} onOpenChange={setIsEmojiPickerOpen}>
                    <PopoverTrigger asChild>
                        <span style={{ cursor: "pointer", fontSize: "24px", marginInlineEnd: "5px" }}>
                            {emoji}
                        </span>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                        <EmojiPicker onEmojiClick={setBoardIcon} />
                    </PopoverContent>
                </Popover>
                <BTtextFieldWithLabel
                    placeholder="Board Name"
                    name="firstName"
                    value={boardName}
                    autoFocus
                    onChange={(e) => setBoardName(e.target.value)}
                    sx={{
                        backgroundColor: 'var(--tasks-board-bg)',
                    }}
                />
            </Stack>
            <Divider />
            <FormControl component="fieldset">
                <FormLabel component="legend"
                    sx={{ marginBottom: "16px" }}>
                    Select what you're managing in this board
                </FormLabel>

                <RadioGroup row
                    aria-label="options"
                    name="options"
                    value={selectedValue}
                    onChange={handleChange}
                >
                    <Grid sx={{ maxWidth: "550px" }} container >
                        {options.map((option, index) => (
                            <Grid item  xs={6} sm={4} key={option}>
                                <FormControlLabel sx={{ textTransform: "capitalize" }} value={option} control={<Radio />} label={option} />
                            </Grid>
                        ))}
                    </Grid>

                </RadioGroup>
            </FormControl>
            <Stack>
                <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={3} my={2}>
                    <BTButton onClick={() => dispatch(modalActions.setComponentToRender(''))} btvariant='text' sx={{ textTransform: "capitalize" }}>Cancel</BTButton>
                    <BTButton loading={isNewBoardLoading}
                        onClick={createBoard} >Create board</BTButton>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default NewBoardDialog